import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class DeviceIdService {

  private cachedUuid: string | null = null;

  async getDeviceUuid(): Promise<string> {
    // 1. memory cache
    if (this.cachedUuid) {
      return this.cachedUuid;
    }

    // 2. persistent storage (Capacitor)
    const value =  localStorage.getItem('DEVICE_UUID_KEY')

    if (value) {
      this.cachedUuid = value;
      return value;
    }

    // 3. generate new UUID (FIRST INSTALL ONLY)
    const newUuid = uuidv4();

    localStorage.setItem('DEVICE_UUID_KEY', newUuid);

    this.cachedUuid = newUuid;

    return newUuid;
  }
}